import setImportance from 'owa-mail-compose-actions/lib/actions/setImportance';
import type { ComposeViewState } from 'owa-mail-compose-store';
import type ImportanceType from 'owa-service/lib/contract/ImportanceType';
import findComposeViewStateById, {
    IdSource,
} from 'owa-mail-compose-actions/lib/utils/findComposeViewStateById';

export const onImportanceToggled = (
    composeId: string | undefined,
    importance: ImportanceType
) => () => {
    if (!!composeId) {
        const viewState = findComposeViewStateById(composeId, IdSource.Compose);
        viewState &&
            setImportance(viewState, viewState.importance === importance ? 'Normal' : importance);
    }
};

export const isImportance = (
    viewState: ComposeViewState | undefined,
    importance: ImportanceType
): boolean => {
    return viewState ? viewState.importance === importance : false;
};
